var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c(
        "v-list",
        _vm._l(_vm.filesList, function(fileItem, index) {
          return _c(
            "v-list-tile",
            { key: index, staticClass: "py-2 file-item" },
            [
              _c("object", {
                staticStyle: { "max-width": "60%" },
                attrs: { height: "80", data: fileItem }
              }),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(index)
                        }
                      }
                    },
                    [_vm._v("\n          Remove\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "inputElRef",
        attrs: { type: "file", multiple: _vm.multiple, hidden: "" },
        on: {
          change: function($event) {
            return _vm.processFiles($event)
          }
        }
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-btn",
            {
              class: !_vm.hasFiles ? _vm.btnClass : null,
              attrs: {
                block: "",
                flat: _vm.hasFiles,
                loading: _vm.loading,
                disabled: _vm.disabled
              },
              on: {
                click: function($event) {
                  return _vm.openFileSelector("inputElRef")
                }
              }
            },
            [
              _vm.filesList.length
                ? [_vm._v("\n      Add More\n    ")]
                : [_vm._v("\n      Select Photo(s)\n    ")]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.uploadingProgress !== null
        ? _c("v-progress-linear", {
            staticClass: "mt-0 pt-0",
            model: {
              value: _vm.uploadingProgress,
              callback: function($$v) {
                _vm.uploadingProgress = $$v
              },
              expression: "uploadingProgress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasFiles
        ? _c(
            "v-btn",
            {
              class: _vm.btnClass,
              attrs: {
                block: "",
                loading: _vm.loading,
                disabled: _vm.disabled
              },
              on: {
                click: function($event) {
                  return _vm.upload()
                }
              }
            },
            [_vm._v("\n    Continue\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6379e414", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6379e414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilesUploadBtn.vue
// module id = null
// module chunks = 